import React from 'react';

const TipOptionsSelector = ({
  totalAmount,
  tipValue,
  setTipValue
}) => {
  // Define tip options
  const tipOptions = [
    {
      id: 'no-tip',
      label: 'No Tip',
      value: 0,
      showAmount: false,
      amount: (0).toFixed(2),
    },
    {
      id: '15',
      label: '15%',
      value: 15,
      amount: ((totalAmount * 15) / 100).toFixed(2)
    },
    {
      id: '20',
      label: '20%',
      value: 20,
      amount: ((totalAmount * 20) / 100).toFixed(2)
    },
    {
      id: '25',
      label: '25%',
      value: 25,
      amount: ((totalAmount * 25) / 100).toFixed(2)
    }
  ];

  return (
    <div className="select-tip-options">
      {tipOptions.map(option => {
        const active = !!totalAmount && tipValue?.toFixed(2) == option.amount;

        return (
          <div
            key={option.id}
            className={`select-tip-option ${active ? 'selected' : ''}`}
            onClick={() => {
              setTipValue(+(option.amount || ''));
            }}
          >
            <span className="select-tip-option-text">{option.label}</span>
            {option.showAmount !== false && (
              <span className="select-tip-option-amount">
                (${option.amount})
              </span>
            )}
          </div>
        )
      })}
    </div>
  );
};

export default TipOptionsSelector;